import { z } from 'zod'

/**
 * Schema base para datos personales
 * Reutilizable en Client y Viatger
 */
export const personSchema = z.object({
  nom: z.string().min(1, 'El nom és obligatori'),
  cognoms: z.string().min(1, 'Els cognoms són obligatoris'),
  email: z.string().email('Email invàlid').optional().or(z.literal('')),
  telefon: z.string().optional(),
  mobil: z.string().optional(),
  data_naixement: z.string().optional(),
  genere: z.enum(['home', 'dona', 'altre', 'no_especificat']).optional(),
  nacionalitat: z.string().optional(),
})

export type PersonFormData = z.infer<typeof personSchema>
